import { PageTitle } from '../components/layout/PageTitle';
import { PublicHolidaysPanel } from '../features/organisation/components/PublicHolidaysPanel';
import { BusinessRecordScopedPage } from './BusinessRecordScopedPage';

export const PublicHolidaysPage = () => <div className="mgo-stack mgo-gap-l">
  <PageTitle title="Public Holidays" />
  <BusinessRecordScopedPage>{({ businessRecordId, businessRecordName, regionCode }) => (
    <PublicHolidaysPanel businessRecordId={businessRecordId} businessRecordName={businessRecordName} regionCode={regionCode} />
  )}</BusinessRecordScopedPage>
</div>;
